module.exports = __webpack_public_path__ + "img/02_uk.14ded44e.svg";